import type { SiteContent } from "../types";

export const defaultContent: SiteContent = {
  branding: {
    logo: "",
    logoAlt: "Vereinslogo des TTC Rehlingen",
  },
  hero: {
    eyebrow: "TTC Rehlingen 1964 e.V.",
    title: "Tischtennis verbindet.",
    lead: "Tischtennis für jedes Alter – mit sportlichem Ehrgeiz, echter Gemeinschaft und viel Freude am Spiel.",
    primaryLabel: "Training entdecken",
    secondaryLabel: "Aktuelles lesen",
    image: "/images/hero-table-tennis.png",
  },
  home: {
    noticeVisible: true,
    noticeTitle: "Lust auf Tischtennis?",
    noticeText: "Ob Anfängerin, Wiedereinsteiger oder erfahrener Mannschaftsspieler: Komm vorbei, lern uns kennen und spiel einfach mit.",
    noticeImage: "",
    noticeButtonLabel: "Probetraining anfragen",
    noticeButtonHref: "/kontakt",
    highlightVisible: true,
    highlightTitle: "Aktueller Hinweis",
    highlightText: "Kurzfristige Änderungen an Trainingszeiten oder Hallenbelegung veröffentlichen wir an dieser Stelle.",
    highlightImage: "",
    highlightButtonVisible: true,
    highlightButtonLabel: "Alle Trainingsinfos",
    highlightButtonHref: "/training",
    aboutTitle: "Mehr als ein Sportverein",
    aboutText: "Seit 1964 bringt der TTC Rehlingen Menschen an einen Tisch. Bei uns zählen Bewegung, Fairness und das gute Gefühl, Teil einer lebendigen Vereinsgemeinschaft zu sein.",
    stats: [
      { value: "1964", label: "gegründet" },
      { value: "2×", label: "Training pro Woche" },
      { value: "100 %", label: "Teamgeist" },
    ],
    values: [
      { title: "Gemeinschaft", text: "Wir gewinnen zusammen, lernen voneinander und feiern miteinander." },
      { title: "Nachwuchs", text: "Junge Talente bekommen bei uns Zeit, Unterstützung und Freude am Sport." },
      { title: "Wettkampf", text: "Vom ersten Ballwechsel bis zum Punktspiel: Jede Entwicklung zählt." },
    ],
  },
  training: {
    title: "Dein Platz an der Platte",
    intro: "Zweimal pro Woche trainieren Jugend und Erwachsene in der Schulturnhalle Rehlingen. Ein Probetraining ist nach kurzer Anmeldung jederzeit möglich.",
    noteVisible: true,
    noteTitle: "Hinweis zum Jugendtraining",
    noteText: "Da die Anzahl der Platten begrenzt ist, bitten wir neue Jugendliche um eine kurze Anmeldung per E-Mail. So können wir ein gutes Training für alle vorbereiten.",
    noteImage: "/images/training.jpg",
    noteButtonLabel: "Jugendtraining anfragen",
    noteButtonHref: "/kontakt",
    location: "Schulturnhalle Rehlingen",
    address: "Beckinger Straße 38, 66780 Rehlingen",
    slots: [
      { day: "Dienstag", youth: "17:30–19:00", adults: "19:00–22:00" },
      { day: "Donnerstag", youth: "17:30–19:00", adults: "19:00–22:00" },
    ],
  },
  chronicle: {
    title: "Unsere Geschichte",
    intro: "Über sechs Jahrzehnte Tischtennis in Rehlingen – getragen von sportlicher Leidenschaft und ehrenamtlichem Engagement.",
    body: `Am 21. April 1964 gründeten 16 Mitglieder den TTC Rehlingen. Bei der Gründungsversammlung im Café Heinrich waren Herbert Dening, Ernst Spelz, Klaus Mauer, Rainer Heffinger, Benno Rupp, Alfred Schramm, Hans Lorreng, Günther Brossette und Hans Steinwender anwesend.

Zum aktiven Spielbetrieb wurden zunächst zwei Herrenmannschaften gemeldet. In den folgenden Jahren wuchs das Interesse am Tischtennissport stetig. Weitere Herren-, Senioren-, Damen- und Nachwuchsmannschaften kamen hinzu. Pokalsiege, Meisterschaften und viele gemeinsame Erlebnisse prägen die Vereinsgeschichte.

Ein besonderer Schwerpunkt liegt seit jeher auf der Nachwuchsarbeit. Mehrere Kreis- und Landeserfolge zeigen, wie nachhaltig diese Arbeit wirkt. Der erste Saarlandmeistertitel der Vereinsgeschichte gelang am 23. Oktober 2011 im Mixed-Wettbewerb der Schüler C.

Bis heute verbindet der TTC Rehlingen sportlichen Anspruch mit familiärer Atmosphäre – und schreibt seine Geschichte an jedem Trainings- und Spieltag weiter.`,
  },
  contact: {
    title: "Lernen wir uns kennen",
    intro: "Fragen zum Training, zu einer Mitgliedschaft oder zum Vereinsleben? Schreib uns – wir melden uns gerne zurück.",
    email: "ttcrehlingen@ttcrehlingen.de",
    phone: "",
    location: "Schulturnhalle Rehlingen",
    address: "Beckinger Straße 38, 66780 Rehlingen",
  },
  board: {
    title: "Unser Vorstand",
    intro: "Ehrenamtlich engagiert, nahbar und mit viel Herz für den TTC Rehlingen.",
    members: [
      { name: "Tim Pauluhn", role: "1. Vorsitzender", email: "timpauluhn@ttcrehlingen.de" },
      { name: "Jürgen Klasen", role: "2. Vorsitzender", email: "juergenklasen@ttcrehlingen.de" },
      { name: "Stefan Klasen", role: "Schriftführer", email: "stefanklasen@ttcrehlingen.de" },
      { name: "Bernd Görgen", role: "Kassenwart", email: "berndgoergen@ttcrehlingen.de" },
      { name: "Joe Meiers", role: "Spielausschuss", email: "joemeiers@ttcrehlingen.de" },
      { name: "Tobias Piry", role: "Jugendwart", email: "tobiaspiry@ttcrehlingen.de" },
      { name: "Thomas Kreuzahler", role: "Pressewart", email: "thomaskreuzahler@ttcrehlingen.de" },
      { name: "Michael Kirsch", role: "Gerätewart", email: "michaelkirsch@ttcrehlingen.de" },
    ],
  },
  imprint: {
    title: "Impressum",
    intro: "Rechtliche Angaben zum Tischtennisclub Rehlingen 1964 e.V.",
    body: `## Angaben gemäß § 5 TMG

Tischtennisclub Rehlingen 1964 e.V.  
Beckinger Straße 38  
66780 Rehlingen-Siersburg

## Kontakt

E-Mail: ttcrehlingen@ttcrehlingen.de

## Vertretungsberechtigter Vorstand

Der Verein wird durch den Vorstand gemäß Satzung vertreten.

Bitte ergänzen Sie vor der Veröffentlichung noch Vereinsregister, Registernummer und die vollständige ladungsfähige Anschrift.`,
  },
  privacy: {
    title: "Datenschutz",
    intro: "Informationen zur Verarbeitung personenbezogener Daten auf dieser Website.",
    body: `## Datenschutz auf einen Blick

Diese Website verarbeitet nur die Daten, die für den technischen Betrieb und die von Ihnen angefragte Kommunikation erforderlich sind.

## Kontaktaufnahme

Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung der Anfrage verarbeitet. Die Daten werden nicht ohne Ihre Einwilligung weitergegeben.

## Administration

Der Administrationsbereich verwendet eine geschützte Anmeldung. Dabei werden technisch notwendige Sitzungsinformationen gespeichert.

## Verantwortliche Stelle

Tischtennisclub Rehlingen 1964 e.V.  
E-Mail: ttcrehlingen@ttcrehlingen.de

Diese Vorlage ersetzt keine rechtliche Prüfung. Vor Veröffentlichung sollten Hosting, Protokollierung und eingesetzte Dienste ergänzt werden.`,
  },
  downloads: {
    eyebrow: "Gut informiert",
    title: "Downloads",
    intro: "Alle wichtigen Dokumente des TTC Rehlingen auf einen Blick.",
    documents: [
      { id: "membership-form", title: "Beitrittserklärung", text: "Mitglied beim TTC Rehlingen werden", href: "/docs/Beitrittserklärung.pdf" },
      { id: "statutes", title: "Satzung", text: "Die Vereinssatzung als PDF", href: "/docs/Satzung.pdf" },
      { id: "privacy-registration", title: "Datenschutz-Anmeldung", text: "Ergänzende Datenschutzunterlagen", href: "/docs/DsTTAnmeldung.pdf" },
    ],
  },
  teams: {
    eyebrow: "TTC im Spielbetrieb",
    title: "Unsere Mannschaften",
    intro: "Alle gemeldeten Mannschaften, Ligen und Ergebnisse – übersichtlich nach Saison geordnet.",
    currentSeasonId: "",
    seasons: [],
  },
  headers: {
    home: { image: "/images/hero-table-tennis.png", desktopX: 50, desktopY: 54, mobileX: 50, mobileY: 54 },
    news: { image: "/images/heimsieg.jpeg", desktopX: 50, desktopY: 50, mobileX: 50, mobileY: 50 },
    teams: { image: "/images/team.jpeg", desktopX: 50, desktopY: 50, mobileX: 50, mobileY: 50 },
    training: { image: "/images/halle.jpg", desktopX: 50, desktopY: 50, mobileX: 50, mobileY: 50 },
    club: { image: "/images/team.jpeg", desktopX: 50, desktopY: 50, mobileX: 50, mobileY: 50 },
    contact: { image: "/images/hero-table-tennis.png", desktopX: 50, desktopY: 50, mobileX: 50, mobileY: 50 },
  },
};
